import styled from 'styled-components';

export const OptionsImage = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const StyledSelect = styled.select`
  width: min(100%, 9.5rem);
  height: 1.75rem;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  padding: 0 1.8rem 0 0.5rem;
  background-color: #ebebeb;
  color: #111827;
  font-size: 0.86rem;
  font-family: 'Inter', sans-serif;
  box-sizing: border-box;
  appearance: none;
  outline: none;
  cursor: pointer;

  &:focus {
    border-color: #93c5fd;
    box-shadow: 0 0 0 2px rgba(147, 197, 253, 0.35);
  }
`;

export const BoardWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;

  &::-webkit-scrollbar { width: 8px; height: 8px; }
  &::-webkit-scrollbar-track { background: #c0c0c0; border-radius: 10px; }
  &::-webkit-scrollbar-thumb { background-color: #ffffff; border-radius: 10px; border: 2px solid #c0c0c0; }
`;

export const BoardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
  padding-right: 10px;
`;

export const BoardCard = styled.div`
  background: #f7f7f7;
  border: 1px solid #efefef;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const CreateBoardCard = styled.button`
  min-height: 262px;
  border: 2px dashed #d5d5d5;
  border-radius: 16px;
  background: #f1f1f1;
  color: #8a8a8a;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;

  span { font-size: 16px; font-weight: 700; }
  &:hover { border-color: #bfbfbf; background: #ececec; color: #767676; }
`;

export const BoardCoverArea = styled.div<{ $background: string }>`
  height: 140px;
  background: ${(props) => props.$background};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
`;

export const BoardCoverImage = styled.img<{ $scale?: number | null; $posX?: number | null; $posY?: number | null }>`
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform-origin: ${(props) => props.$posX ?? 50}% ${(props) => props.$posY ?? 50}%;
  transform: scale(${(props) => props.$scale ?? 1});
`;

export const BoardCoverFallback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #7a7a7a;

  span { font-size: 12px; font-weight: 600; }
`;

export const BoardInfo = styled.div`
  padding: 14px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BoardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 28px;
`;

export const BoardCode = styled.span`
  color: #8d8d8d;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

export const BoardTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #101010;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BoardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 6px;
`;

export const TagBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
